// Minimal SW registration helper for JustDeliver PWA.
// Registers only in production builds; safely no-ops if SW is unsupported.
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;
  // Only register on http(s) production builds (CRA dev server breaks with SW caching)
  if (process.env.NODE_ENV !== 'production') return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then((reg) => {
        // When a new SW is found, activate it as soon as the page is idle
        if (reg.waiting) reg.waiting.postMessage({ type: 'SKIP_WAITING' });
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              installing.postMessage({ type: 'SKIP_WAITING' });
            }
          });
        });
      })
      .catch(() => {
        /* SW registration is best-effort; never break the app on failure */
      });

    // Reload once when the new SW takes control so users get the latest assets
    let refreshed = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshed) return;
      refreshed = true;
      window.location.reload();
    });
  });
}
